<script setup lang="ts">
  import { ColoredButton } from '@/shared/ui/';
  import { formatInstantToPtBR } from '@/shared/lib';
  import type { ProofRevision } from '../model/types';
  defineProps<{
    proofRevision: ProofRevision;
  }>();

  const emit = defineEmits<{
    (e: 'criar-prova', id: number): void;
  }>();
</script>

<template>
  <tr class="table-row-hover border-t border-gray-02 transition-colors duration-300 ease-out">
    <td class="px-6 py-4">
      {{ formatInstantToPtBR(proofRevision.createdAt) }}
    </td>
    <td class="px-6 py-4 whitespace-nowrap">
      {{ proofRevision.documentName }}
    </td>
    <td class="px-6 py-4">
      {{ proofRevision.elaboratedBy }}
    </td>
    <td class="px-6 py-4">
      {{ proofRevision.approvedBy }}
    </td>
    <td class="px-6 py-4">
      <ColoredButton
        text="Criar prova"
        class="!py-2.5 !text-sm whitespace-nowrap"
        @click="emit('criar-prova', proofRevision.id)"
      />
    </td>
  </tr>
</template>
